import * as Yup from 'yup';
import i18next from 'i18next';

export default Yup.object().shape({
  payForm: Yup.string().required(i18next.t('common.validation.required')),
  voucher: Yup.string().required(i18next.t('common.validation.required')),
});
